// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A widget ideal for integrating primary source documents into your stories.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Tearout excerpt",
  id: "tearout-excerpt",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/tearout-excerpt/?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "TearoutExcerptConfigTool" */ "app/components/tools/TearoutExcerptConfigTool/TearoutExcerptConfigTool"),
    loading: DynamicImportLoader,
    modules: ["TearoutExcerptConfigTool"]
  })
};

export default CONFIG;
